import { useSorEntityName } from '@/hooks/useSorEntityName';
import { organizationOnLetter } from '@/lib/medcom/letterDisplay';
import {
  organizationDisplayName,
  organizationFieldsFromStored,
  sorIdFromOrganizationLabel,
} from '@/lib/medcom/sorEntityName';

/**
 * Organisation name from the letter. When the letter has no name, the name of
 * the SOR id is looked up. If the lookup finds none, the SOR id is shown, and
 * without a SOR id the fallback.
 */
export function OrganizationName({
  name,
  sorId,
  fallback,
}: {
  name: string | null | undefined;
  sorId: string | null | undefined;
  fallback: string;
}) {
  const party = organizationFieldsFromStored(name, sorId);
  const fromSor = useSorEntityName(party.name ? null : party.sorId);
  return (
    <>
      {organizationDisplayName(party.name, fromSor.name) ??
        (organizationOnLetter(party.name, party.sorId) || fallback)}
    </>
  );
}

/**
 * A signature organisation that is only `SOR <id>` is shown with the name of
 * that SOR id. Any other label is shown as it is.
 */
export function OrganizationLabel({ label }: { label: string | null | undefined }) {
  const sorId = sorIdFromOrganizationLabel(label);
  const fromSor = useSorEntityName(sorId);
  return <>{fromSor.name ?? label ?? ''}</>;
}
